import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

import type {SelectionType, SetSelectionType} from '@pb/kit-component-selection';


export type Props = {
    selection: SelectionType,
    dataRows: Array<number | string>,
    setSelection: SetSelectionType,
    showSelectPage?: boolean,
};

export const SelectPageView = (props: Props) => {
    const {
        selection: {ids, inverted},
        dataRows,
        setSelection,
        showSelectPage = true,
    } = props;

    const selectPage = () => {
        setSelection({
            inverted,
            ids: dataRows.reduce((save, id) => {
                if (!inverted) {
                    if (save.includes(id)) {
                        return save;
                    }

                    return [...save, id];
                } else {
                    return save.filter(i => i !== id);
                }
            }, ids),
        });
    };

    const disabled = inverted
        ? !dataRows.some(id => ids.includes(id))
        : dataRows.every(id => ids.includes(id));

    return !disabled && showSelectPage ? (
        <ToolItem>
            <FlatButton
                disabled={disabled}
                onClick={selectPage}>
                <strong>Select Page</strong>
            </FlatButton>
        </ToolItem>
    ) : null;
};
